import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const UserTypes = {
    GUEST: 'guest',
    PATIENT: 'patient',
    SYSTEM_USER: 'system-user'
}

export const SYSTEM_USER_RIGHTS = {
    SYSTEM_USER: "system_user",
    PATIENT: 'patient',
    SDG: 'sdg'
}

export const AxiosConfigHeaders = {
    SU_API_KEY: "API-KEY-WROOT-PATIENT-WEB",
    AU_API_KEY: "API-KEY-WROOT-PATIENT-WEB",
    SU_REQ_FROM: "usr",
    AU_REQ_FROM: "usr",
    TZ_OFFSET: dayjs().utcOffset(),
    TZ_STR: dayjs.tz.guess()
}

export const VALIDATION_REGEX = {
    CONTACT_NUMBER: /^\d{10}$/,
    // PHONE_NUMBER: /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
}

export const TEXT = {
    SAVE: "Save",
    CANCEL: "Cancel",
    ADD: "Add",
    EDIT: "Edit",
}